export default abstract class DomainModel {
  private __constraintDomainModel = null
}
